import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import { useRecoilState, useRecoilValue } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { useHippoText } from '../../../../hooks/useHippoText';
import { Link, NumberField } from '@flos/react-ui';
import ViewInformationModal from '../../../../shared_components/ViewInformationModal/ViewInformationModal';
import { useState } from 'react';
import { useUpdateCoverableInformation } from '../../../../recoil/hooks/useUpdateCoverableInformation';
import { useSaveCoverableInformation } from '../../../../hooks/useSaveCoverableInformation';
import type { CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { track } from '../../../../utils/trackingUtil';
import CallMeModal from '../../../../shared_components/CallMeModal/CallMeModal';
import { COVERABLE_CODE } from '../../../../constants/coverable';

const HouseAgeOfOldestInHouseholdStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [coverables] = useRecoilState(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const { saveCoverableInformation } = useSaveCoverableInformation();
    const houseCoverables =
        currentProduct.flavourCode === COVERABLE_CODE.prhHouse
            ? coverables.houses ?? []
            : coverables.holidayHomes ?? [];
    const coverableIndex = houseCoverables?.findIndex(
        (coverable) => coverable.fixedId === currentProduct.fixedId
    );
    const currentHouseCoverable = houseCoverables[coverableIndex];
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [age, setAge] = useState<number | undefined>(
        currentHouseCoverable.ageOfOldestInHousehold ?? undefined
    );
    const [showCallMeModal, setShowCallMeModal] = useState<boolean>(false);

    const viewInformationModalHouse = {
        title: getHippoText('DSS-COVERABLE-INFORMATION-STEP- AGE-WHY-DO-YOU-ASK'),
        description: getHippoText('DSS-COVERABLE-INFORMATION-WHY-DO-YOU-ASK-PRH-BODY')
    };

    const onNext = (): void => {
        if (age === undefined || age < 18) {
            setShowCallMeModal(true);
            return;
        }
        setIsLoading(true);
        const updatedCoverable: CoverableInformationToUpdateDTO = {
            [currentProduct.flavourCode === COVERABLE_CODE.prhHouse ? 'house' : 'holidayHome']: {
                publicId: currentHouseCoverable.publicId,
                fixedId: currentHouseCoverable.fixedId,
                ageOfOldestInHousehold: currentHouseCoverable.ageOfOldestInHousehold
            },
            productToUpdate: currentProduct.flavourName
        };

        void saveCoverableInformation(updatedCoverable).then(() => {
            setIsLoading(false);
            track(`${currentProduct.flavourName}CoverableInformationAgeOfOldestInHousehold`, [
                {
                    ageOfOldestInHousehold: currentHouseCoverable.ageOfOldestInHousehold
                }
            ]);
            goNext();
        });
    };

    return (
        <WizardPagetemplate onNext={onNext} onPrevious={goPrevious} disableNext={isLoading || !age}>
            <CoverableDetailsTemplate
                header={getHippoText('DSS-COVERABLE-INFORMATION-STEP-AGE-HEADER')}
            >
                <NumberField
                    label={getHippoText('DSS-COVERABLE-INFORMATION-STEP- AGE-INPUTFIELD')}
                    value={age?.toString()}
                    onChange={(event) => {
                        setAge(parseInt(event.target.value));
                    }}
                    onBlur={(event): void => {
                        updateCoverableInformation({
                            ageOfOldestInHousehold: parseInt(event.target.value)
                        });
                    }}
                    minLength={1}
                />
                <Link
                    className="u-flex-items-stretch"
                    onClick={() => {
                        setShowModal(true);
                    }}
                    theme="logo"
                >
                    {getHippoText('DSS-COVERABLE-INFORMATION-STEP- AGE-WHY-DO-YOU-ASK')}
                </Link>
            </CoverableDetailsTemplate>
            {showModal && (
                <ViewInformationModal
                    showModal={showModal}
                    modalProps={viewInformationModalHouse}
                    closeModal={() => {
                        setShowModal(false);
                    }}
                />
            )}
            <CallMeModal
                activityCode="dss_call_request"
                showModal={showCallMeModal}
                closeModal={() => {
                    setShowCallMeModal(false);
                }}
                title={getHippoText('DSS-CALL-ME-MODAL-NO-PRICE-HEADER')}
                description={
                    getHippoText('DSS-CALL-ME-MODAL-NO-PRICE-SUBHEADER') +
                    ' ' +
                    getHippoText('DSS-CALL-ME-MODAL-NO-PRICE-BOOK-CALL-SUBHEADER')
                }
            />
        </WizardPagetemplate>
    );
};

export default HouseAgeOfOldestInHouseholdStep;
